<template>
  <card-wrapper v-if="coupon"
    max-height="none"
    :forced-height="106"
    :forced-width="284"
    :min-width="284"
    :clearActive="clearCoupon"
    :onClick="openConfig"
    :image="getImage(coupon)"
    :isActive="isActive(coupon) && !immutable"
  >
    <template v-slot:textBody> 
      <div class="coupon-text-body">
        <div class="header" :class="{'error-title': isDisabled}">
          {{ coupon.name }}
        </div>
        <div class="rules-container">
          <!-- <div>
            {{coupon.description}}
          </div> -->

          <div v-if="discountCapText" class="discount-cap-rule">
            • {{ discountCapText }}
          </div>
          <div v-if="hasRules && hasRules.length">
            <div v-for="rule in hasRules" :key="rule">
              • {{ rule }}
            </div>
          </div>
          <div v-if="!discountCapText && (!hasRules || !hasRules.length)">
            • {{ $vuetify.t('$vuetify.account.rewards.noLimitation') }}
          </div>
        </div>

        <div class="offer-expiry" v-if="getExpirationDescription">
          {{ getExpirationDescription }}
        </div>
        <div v-else class="offer-expiry">
          {{ $vuetify.t('$vuetify.account.rewards.noExpiration') }}
        </div>
      </div>
    </template>
    <template v-if="showItems && coupon.orderItem && coupon.orderItem.childItemList" v-slot:description>
      <div v-for="relation in coupon.orderItem.childItemList || []">
        <v-layout v-for="item in relation.childItemList" :key="item.code" class="menuItemContainer">
          <v-flex xs10>
            <div class="itemName">
              {{ item.qty || 1 }} x {{ findDisplayText(item || item) }}
            </div>

            <ul class="cart-list">
              <li v-for="(config, index) in fetchConfigItems(item)" :key="index">
                {{ config.qty && config.qty > 1 ? `${config.qty} x ` : '' }}
                {{ config.name }}
                <span v-if="config.price" class="caption grey--text">
                  {{config.price | currency }}
                </span>
              </li>
            </ul>
          </v-flex>

          <v-flex xs2>
            <span v-if="'itemPrice' in item && 'unitDiscount' in item && item.unitDiscount < 0" class="mr-2 caption" style="text-decoration: line-through;">
              <span class="red--text">
                {{ (item.itemPrice - item.unitDiscount) | currency}}
              </span>
            </span>

            <template v-if="'itemPrice' in item">
              <template v-if="item.itemPrice">
                {{ item.itemPrice | currency }}
              </template>
            </template>
            <common-price v-else class="mr-2" :init-charges="item.charges || []" />
          </v-flex>
        </v-layout>
      </div>
    </template>
    <template v-else-if="isPurchasable" v-slot:description>
      Add to account for:
      <common-price class="mr-2" :init-charges="coupon.charges.map(charge => {return {...charge, price: charge.value}})" />
    </template>
  </card-wrapper>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { matchTranslation } from "@/services/util.service"
import { formatDiscountCap } from "@/services/currency.service"
import get from 'lodash/get';


import CommonPrice from "@/components/Common/CommonPrice"
import CardWrapper from "@/components/Wrappers/CardWrapper"
import HeaderBarApps from '@/components/ExternalAppsLinks'

export default {
  components: { CardWrapper, CommonPrice },
  extends: HeaderBarApps,

  props: {
    coupon: {
      type: Object,
      default: null
    },

    allowConfig: {
      type: Boolean,
      default: false
    },

    showItems: {
      type: Boolean,
      default: false
    },

    immutable: {
      type: Boolean,
      default: false
    },

    maxWidth: {
      type: String,
      default: '350px'
    }
  },

  computed: {
    isDisabled() {
      return !get(this.coupon, 'eligibilityResult.isEligible', true) && !this.isPurchasable
    },
    isPurchasable() {
      return !!this.coupon.charges && !this.coupon.uuid
    },

    hasRules() {
      return get(this.coupon, 'eligibilityResult.ruleDescriptions', [])
    },

    // maxDiscountAmount is only set for capped percentage coupons, in cents.
    discountCapText() {
      const cap = formatDiscountCap(this.coupon.maxDiscountAmount, this.getCurrencyCode)
      return cap ? this.$vuetify.t('$vuetify.account.rewards.maxDiscountOf', cap) : null
    },

    getExpirationDescription() {
      return get(this.coupon, 'eligibilityResult.expirationDescription') || get(this.coupon, 'ruleResult.expirationDescription')
    },

    ...mapGetters([ 'getStore', 'getExistingOrder', 'getActiveCoupon', 'isLoggedIn', 'getFinalChargeFromCharges', 'getOrderType', 'getUserID', 'getCurrencyCode' ])
  },

  methods: {
    fireCouponEvent(eventName, coupon) {
      try {
        const payload = {
          coupon_code: coupon.code || '',
          coupon_name: coupon.name || '',
          order_type: this.getOrderType || '',
          store_id: String((this.getStore && this.getStore.storeId) || ''),
        }
        if (this.getUserID) payload.user_id = String(this.getUserID)
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({ event: eventName, ...payload })
        if (typeof window.gtag === 'function') window.gtag('event', eventName, payload)
      } catch (e) { console.warn(eventName + ' tracking error', e) }
    },

    getImage(coupon) {
      if (coupon.imageUrl)
        return `${process.env.VUE_APP_API_IMAGE}${coupon.imageUrl}`
      return null;
    },
    openLoginDialog() {
      this.showSnack({
        text: this.$vuetify.t('$vuetify.account.rewards.loginPrompt', [this.coupon.name]),
        color: 'secondary'
      })

      this.setLoginDialog(true)
    },

    addToCart(activeCoupon) {
      this.fireCouponEvent('coupon_added', this.coupon)
      this.SET_ACTIVE_COUPON({
        code: this.coupon.code,
        name: this.coupon.name,
        description: this.coupon.description,
        imageUrl: this.coupon.imageUrl,
        uuid: this.coupon.uuid,
        purchase: !!this.coupon.charges,
        charges: this.coupon.charges,
        orderItem: null
      })

      this.showSnack({
        text: this.$vuetify.t('$vuetify.common.addedToCart', [this.coupon.name]),
        color: 'secondary'
      })

      this.fetchShoppingCart()
    },

    checkCouponValididity(activeCoupon) {
      if (!this.allowConfig)
        return false

      if (this.isDisabled) {
        this.showSnack({
          text: this.$vuetify.t('$vuetify.account.rewards.inEligible'),
          color: 'error'
        })
        return false
      }

      // If there is an active coupon, the coupon must be the active one to configure it
      if (activeCoupon && activeCoupon.code !== this.coupon.code) {
        this.showSnack({
          text: 'Please remove your active coupon first',
          color: 'error'
        })
        return false
      }

      if (this.getExistingOrder.length) {
        // Cannot add a coupon if a previous sub order already used one
        if (!!this.getExistingOrder.find(order => order.coupons && order.coupons.length)) {
          this.showSnack({
            text: 'A previous order already used a coupon',
            color: 'error'
          })
          return false
        }
      }

      return true
    },

    openConfig() {
      const activeCoupon = this.getActiveCoupon[0]
      if (!this.checkCouponValididity(activeCoupon))
        return
      this.fireCouponEvent('coupon_opened', this.coupon)

      if (this.isPurchasable) {
        if (!this.isLoggedIn) {
          this.openLoginDialog()
        } else {
          window.open(this.buildCouponUrl, '_self')
        }
      } else if (('menuItem' in this.coupon || 'orderItem' in this.coupon) || !this.isLoggedIn) {
        // If there's no config but the user is not logged in, log in to check if the user has the coupon
        this.setCouponItemDialog(JSON.parse(JSON.stringify(activeCoupon || this.coupon)))
      } else if (activeCoupon) {
        // If the coupon has no config and is already active, no need to re-add it
        this.showSnack({
          text: this.$vuetify.t('$vuetify.account.rewards.alreadyInCart', [this.coupon.name]),
          color: 'secondary'
        })
      } else {
        // if the coupon doesn't have any configuration, we can skip opening the config
        this.addToCart(activeCoupon)
      }
    },

    isActive(coupon) {
      const active = get(this.getActiveCoupon, '[0]')

      // If the coupon has a uuid, using that to identify it is more accurate
      // But non instance versions will not. So fall back on matching the code
      if (!!active) {
        const couponIdentifier = coupon.uuid || coupon.code
        const activeIdentifier = active.uuid || active.code

        return couponIdentifier == activeIdentifier
      }

      return false
    },

    clearCoupon() {
      this.removeCoupon(null)
      this.fetchShoppingCart()
    },

    fetchConfigItems(item) {
      let configItems = []
      // History items use standard childItemList wrapper structure. Fallback is normal case
      const list = get(item, 'itemAttributeList', [])

      list.map(option => {
        option.attrValueList.forEach(opt => {
          configItems.push(opt)
        })
      })

      return configItems.filter(Boolean)
    },

    findDisplayText(item) {
      const translations = get(item, 'nameTranslation.translations', null)

      return matchTranslation(translations) || item.name || item.value || ''
    },

    ...mapActions([ 'fetchShoppingCart', 'setCouponItemDialog', 'removeCoupon', 'showSnack' ]),
    ...mapMutations([ 'SET_ACTIVE_COUPON', 'setLoginDialog' ])
  }
}
</script>

<style scoped>
  .rules-container {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-word;
    font-size: 11px;
    font-weight: 600;
    color: grey;
    line-height: 1.4; 
  }

  .rule-text {
    white-space: normal; 
  }
  .menuItemContainer {
    margin-top: 20px;
  }
  .itemName {
    font-size: 16px;
    color: var(--v-primary-base);
  }
  .itemPrice {
    font-size: 14px;
    color: var(--v-secondary-base);
  }
  
  .header {
    color: var(--v-primary-base);
  }
  
  .error-title {
    color: #D8000C
  }

  .coupon-text-body {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .offer-expiry {
    font-size: 10px;
    color: #757575;
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
  }
</style>
